export default {
  'signup.name': 'Persona',
  'signup.insurance': 'Versicherung',
  'signup.insurance-type': 'Versicherungsart',
  'signup.insurance-number': 'Versichertennummer',
  'signup.insurer-number': 'Versicherungsnummer',
  'signup.contact': 'Kontakt',
  'signup.password': 'Passwort',

  'signup.required-field': 'Dieses Feld muss gesetzt werden',
  'signup.prefix.mr': 'Herr',
  'signup.prefix.ms': 'Frau',
  'signup.first-name': 'Vorname',
  'signup.last-name': 'Nachname',
  'signup.sex': 'Geschlecht',
  'signup.sex.none': 'Keine Angabe',
  'signup.title': 'Titel',
  'signup.date-of-birth': 'Geburtsdatum',
  'signup.sex.tooltip': 'Wir garantieren, dass keine personenbezogenen Daten weitergegeben werden',
  'signup.date-of-birth.tooltip':
    'Wir garantieren, dass keine personenbezogenen Daten weitergegeben werden',
  'signup.summary': 'Zusammenfassung',
  'signup.summary.description': 'Bitte überprüfen Sie, ob die eingegebenen Daten stimmen.',

  'signup.invalid-email': 'Bitte geben Sie eine gültige E-Mail-Adresse an',
  'signup.invalid-phone': 'Ungültige Telefonnummer',

  'signup.phone': 'Telefonnummer',
  'signup.e-mail': 'E-Mail',

  'signup.password.tooltip': 'Ihr Passwort muss mehr als {minCount} Zeichen beinhalten',
  'signup.password-repetition': 'Passwort Wiederholung',

  'password-validation.minLength': 'Passwort hat mindestens {length} Zeichen',
  'password-validation.number': 'Passwort beinhaltet eine Zahl',
  'password-validation.match': 'Passwörter stimmen überein',
  'password-validation.capital': 'Passwort beinhaltet Großbuchstaben',
  'password-validation.specialChar': 'Passwort beinhaltet ein Sonderzeichen',

  'create-user': 'Konto erstellen',
  'create-user.success': 'Konto wurde erfolgreich erstellt',
  'create-user.error': 'Beim Erstellen des Kontos ist ein Fehler aufgetreten',
  'create-user.error.description':
    'Bitte überprüfen Sie ob Sie bereits ein Konto mit der angegebenen E-Mail Adresse haben.',
  'create-user.success.description': 'Sie können sich nun mit Ihren Zugangsdaten einloggen',

  'captcha.solve': 'Bitte Captcha lösen',
  'captcha.error': 'Captcha konnte nicht gelöst werden',

  'existing-user': 'Es existiert bereits ein Konto mit den angegebenen Kontaktdaten',
  'existing-user.phone': 'Die angegebene Telefonnummer ist bereits mit einem Konto verknüpft.',
  'existing-user.email': 'Die angegebene E-Mail ist bereits mit einem Konto verknüpft.',
  'existing-user.email-phone':
    'Die angegebene E-Mail oder Telefonnummer sind bereits mit einem Konto verknüpft.',
  'existing-user.to-login': 'Zum Login',
  'existing-user.change-phone': 'Telefonnummer ändern',
  'existing-user.change-email': 'E-Mail ändern',
  'existing-user.change-email-phone': 'E-Mail und Telefonnummer ändern',

  'terms-and-conditions': 'Nutzungsbedingungen',
  privacy: 'Datenschutzerklärung',

  '2fa.error': 'Zwei-Faktor-Authentifizierung fehlgeschlagen',
  '2fa.error.description': 'Bitte überprüfen Sie Ihre Eingabe.',

  'password-mismatch': 'Bitte geben Sie zweimal dasselbe Passwort ein',
  'change-password.error':
    'Passwort konnte nicht geändert werden. Bitte überprüfen Sie die Richtigkeit des eingegebenen Passworts.',

  'account-verification': 'Konto verifizieren',
  'account-verification.two-factor': 'Zwei-Faktor-Authentifizierung',
  'account-verification.description':
    'Ihnen wurde soeben eine E-Mail mit einem Verifizierungslink an {email} gesendet. Öffnen Sie bitte den Link in der E-Mail oder geben Sie den Code aus der E-Mail ein, um Ihr Konto zu verifizieren.',
  'account-verification.invalid-code': 'Ungültiger Code - Bitte probieren Sie die Eingabe erneut.',
  'account-verification.valid-until': 'Gültig bis',
  'account-verification.no-email': 'Keine E-Mail erhalten?',

  'email-confirmation': 'E-Mail Bestätigung',
  'email-confirmation.two-factor': 'Zwei-Faktor-Authentifizierung',
  'email-confirmation.description':
    'Ihnen wurde eine E-Mail mit einem Bestätigungslink geschickt. Um sich anzumelden, öffnen Sie bitte den Link in der E-Mail oder geben Sie den Code aus der E-Mail hier ein.',
  'email.resent': 'E-Mail wurde erneut versendet',
  'email.resent.description': 'Bitte überprüfen Sie Ihr E-Mail Postfach für {email}',

  'error.login': 'E-Mail oder Passwort falsch. Bitte überprüfen Sie Ihre Zugangsdaten',

  'auth-required': 'Anmeldung benötigt',
  'auth-required.description': 'Sie müssen angemeldet sein, um diese Seite besuchen zu können.',

  'back-to-booking': 'Zurück zur Buchung',
  'back-to-destination': 'Zurück zur Anwendung',

  'confirmable-action.action-token-sent.email.title':
    'Ein Bestätigungslink wurde an Ihre E-Mail versendet.',

  'confirmable-action.action-token-sent.email-partial.sub-title':
    'Sie können hier fortfahren, sobald der Link bestätigt wurde.',
  'confirmable-action.action-token-sent.email-partial.done': 'Ich habe den Link bestätigt',

  'confirmable-action.action-token-sent.email-full.sub-title':
    'Sie sind hier fertig, fahren Sie mit dem Link fort.',
  'confirmable-action.action-token-sent.email-full.done': 'Verstanden',
  'confirmable-action.skip': 'Überspringen',

  'go-to-login': 'Zum Log-In',

  'account-verification.already-verified': 'Konto wurde bereits bestätigt',
  'account-verification.error': 'Verifizierung fehlgeschlagen',
  'account-verification.in-progress': 'Konto wird verifiziert...',
  'account-verification.success.title': 'Konto Bestätigung abgeschlossen',
  'account-verification.success.description':
    'Ihr Account wurde erfolgreich bestätigt. Sie können sich nun einloggen.',
  'account-verification.error.title': 'Da ist etwas schief gelaufen',
  'account-verification.error.description':
    'Es ist ein Fehler aufgetreten. Ihr Konto konnte nicht verifiziert werden oder wurde bereits verifiziert.',
};
